import { useRef } from 'react'

export default function Magnetic({ children, strength = 0.22 }) {
  const ref = useRef(null)
  const rectRef = useRef(null)

  // Reading getBoundingClientRect() on every mousemove forces a synchronous
  // layout recalculation once any element's style has been written this
  // frame (including this one's own transform from the previous event) —
  // cache it once on enter instead, since the element doesn't move or
  // resize during a hover.
  const handleMouseEnter = () => {
    const el = ref.current
    if (el) rectRef.current = el.getBoundingClientRect()
  }

  const handleMouseMove = (e) => {
    const el = ref.current
    const rect = rectRef.current
    if (!el || !rect) return
    const dx = (e.clientX - (rect.left + rect.width  / 2)) * strength
    const dy = (e.clientY - (rect.top  + rect.height / 2)) * strength
    el.style.transform  = `translate(${dx}px, ${dy}px)`
    el.style.transition = 'transform 0.1s linear'
  }

  const handleMouseLeave = () => {
    const el = ref.current
    if (!el) return
    el.style.transform  = 'translate(0px, 0px)'
    el.style.transition = 'transform 0.65s cubic-bezier(.25,.46,.45,.94)'
    rectRef.current = null
  }

  return (
    <div
      ref={ref}
      onMouseEnter={handleMouseEnter}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      style={{ display: 'inline-block' }}
    >
      {children}
    </div>
  )
}
